import { render } from "./ModalFrame.vue?vue&type=template&id=1441d2da&scoped=true"
import script from "./ModalFrame.vue?vue&type=script&lang=js"
export * from "./ModalFrame.vue?vue&type=script&lang=js"

import "./ModalFrame.vue?vue&type=style&index=0&id=1441d2da&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1441d2da"]])

export default __exports__